export default __webpack_public_path__ + "static/ProValue_1@mob-1cf53708bab2c30192aa2f152fb6b7dc.png";